'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'star';
var width = 576;
var height = 512;
var aliases = [11088,61446];
var unicode = 'f005';
var svgPathData = ['M53.7 179.9L157.1 283.3c7.2 7.2 10.6 17.5 9 27.6L143.2 455.3 273.6 389c9.1-4.6 19.9-4.6 29 0l130.3 66.3-22.8-144.4c-1.6-10.1 1.7-20.4 9-27.6l103.3-103.5-144.4-23c-10.1-1.6-18.8-7.9-23.5-17.1L288.1 9.6 221.6 139.8c-4.6 9.1-13.4 15.5-23.5 17.1l-144.4 23z', 'M383 125.3L309.5-18.9c-4.1-8-12.4-13.1-21.4-13.1s-17.3 5.1-21.4 13.1L193.1 125.3 33.2 150.7c-8.9 1.4-16.3 7.7-19.1 16.3s-.5 18 5.8 24.4l114.4 114.5-25.2 159.9c-1.4 8.9 2.3 17.9 9.6 23.2s16.9 6.1 25 2L288.1 417.6 432.4 491c8 4.1 17.7 3.3 25-2s11-14.2 9.6-23.2L441.7 305.9 556.1 191.4c6.4-6.4 8.6-15.8 5.8-24.4s-10.1-14.9-19.1-16.3L383 125.3zm-5 31.6l144.4 23-103.3 103.5c-7.2 7.2-10.6 17.5-9 27.6L432.9 455.3 302.6 389c-9.1-4.6-19.9-4.6-29 0L143.2 455.3 166 310.9c1.6-10.1-1.7-20.4-9-27.6l-103.3-103.5 144.4-23c10.1-1.6 18.8-7.9 23.5-17.1L288.1 9.6 354.5 139.8c4.6 9.1 13.4 15.5 23.5 17.1z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;